import Axios from 'axios'
import {frequencyUrls} from '../urls'

export default {
  get_all_frequency (context) {
    Axios.get(frequencyUrls.getAllFrequency).then(function (response) {
      context.commit('GET_ALL_FREQUENCY', response.data)
    })
  }
}
